import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=2d9ed33b&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9ed33b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d9ed33b')) {
      api.createRecord('2d9ed33b', component.options)
    } else {
      api.reload('2d9ed33b', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=2d9ed33b&scoped=true&", function () {
      api.rerender('2d9ed33b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CiEb1gCe2OFD/JS/comp/Accordion.vue"
export default component.exports